/**
 * Canonical storefront filter query keys (shop + category + shared bookmarks).
 * Legacy aliases are read for backward compatibility but should not be written.
 */
export const SHOP_QUERY = {
  minPrice: 'min_price',
  maxPrice: 'max_price',
  inStock: 'in_stock',
  categoryId: 'category_id',
  minRating: 'min_rating',
  sort: 'sort',
  view: 'view',
} as const

/** @deprecated read-only — use `in_stock` */
const LEGACY_IN_STOCK = 'inStock'
/** @deprecated read-only — use `max_price` */
const LEGACY_MAX_PRICE = 'maxPrice'

export function readInStockOnlyFromSearchParams(sp: URLSearchParams): boolean {
  return sp.get(SHOP_QUERY.inStock) === '1' || sp.get(LEGACY_IN_STOCK) === '1'
}

/** Raw string for controlled max-price input (canonical `max_price`, legacy `maxPrice`). */
export function readMaxPriceRawFromSearchParams(sp: URLSearchParams): string {
  return (sp.get(SHOP_QUERY.maxPrice) ?? sp.get(LEGACY_MAX_PRICE) ?? '').trim()
}

export function readMinPriceRawFromSearchParams(sp: URLSearchParams): string {
  return (sp.get(SHOP_QUERY.minPrice) ?? '').trim()
}

export function parseMoneyQueryParam(s: string | null): number | null {
  if (s == null || s.trim() === '') return null
  const n = Number(s)
  return Number.isFinite(n) && n >= 0 ? n : null
}

/** Remove legacy filter keys after migrating writes to canonical names. */
export function stripLegacyShopFilterParams(sp: URLSearchParams): void {
  sp.delete(LEGACY_IN_STOCK)
  sp.delete(LEGACY_MAX_PRICE)
}
